import { Panel } from "../components/layout/Panel";

type SessionGatePanelProps = {
  status: "checking" | "unavailable";
  error?: string | null;
  retrying?: boolean;
  onRetry?: () => void;
  shellClassName?: string;
};

export function SessionGatePanel({
  status,
  error = null,
  retrying = false,
  onRetry,
  shellClassName = "app-shell",
}: SessionGatePanelProps) {
  return (
    <main className={shellClassName}>
      <Panel>
        {status === "checking" ? (
          <p>Loading session…</p>
        ) : (
          <>
            <h1>Session unavailable</h1>
            <p>We couldn't verify your session right now.</p>
            {error && <p>{error}</p>}
            <button type="button" onClick={onRetry} disabled={!onRetry || retrying}>
              {retrying ? "Retrying session..." : "Retry Session"}
            </button>
          </>
        )}
      </Panel>
    </main>
  );
}
